import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useIsMobile } from "../../../hooks";
import { Typo } from "../../../Typo";
import {
  MobileSortBottomSheet,
  SortOption,
  SortOrder,
} from "../../Common/controls/MobileSortBottomSheet";
import { ReturnedTranslatedContentClientsPageHook } from "../../types";
import { useClientApprovedNotFundedContext } from "../providers/ApprovedNotFundedProvider";

type ClientApprovedNotFundedReportSortProps = {
  isMobileBottomSheetEnable: boolean;
  translations: ReturnedTranslatedContentClientsPageHook;
};

export const ClientApprovedNotFundedReportSort = ({
  isMobileBottomSheetEnable,
  translations,
}: ClientApprovedNotFundedReportSortProps) => {
  const {
    state: { sortOrder },
    actions: { setSort },
    runResource,
  } = useClientApprovedNotFundedContext();
  const isMobile = useIsMobile();

  const { t } = useTranslation();

  const approvalDateLabel =
    translations.translatedContent.approvedNotFundedTab
      .approvedNotFundedColumnLabels.approvalDate;

  const sortOptions: SortOption[] = useMemo(
    () => [
      {
        id: "desc",
        label: `${approvalDateLabel}: ${t("clientsPage_sort_Bottomsheet_newestFirst")}`,
      },
      {
        id: "asc",
        label: `${approvalDateLabel}: ${t("clientsPage_sort_Bottomsheet_oldestFirst")}`,
      },
    ],
    [approvalDateLabel, t],
  );

  if (!isMobileBottomSheetEnable || !isMobile) {
    return null;
  }

  return (
    <div className="sticky top-[136px] z-10 -mb-4 bg-surface-primary pb-2">
      <div className="flex h-10 items-center gap-6">
        <div className="min-w-0 flex-1">
          <MobileSortBottomSheet
            sortOptions={sortOptions}
            selectedSortBy={sortOrder ?? "desc"}
            selectedSortOrder={sortOrder ?? "desc"}
            onApply={(selectedOrder) =>
              setSort("approvalDate", selectedOrder as SortOrder)
            }
            showSortOrder={false}
            triggerLabel={approvalDateLabel}
          />
        </div>
        <div className="flex shrink-0 flex-row items-center">
          <button
            onClick={() => runResource("csv")}
            className="flex h-10 cursor-pointer items-center justify-center rounded-lg bg-surface-tonal-default px-3 py-2"
          >
            <Typo type="labelSM" classes="whitespace-nowrap">
              {translations.translatedContent.exportCSVText}
            </Typo>
          </button>
        </div>
      </div>
    </div>
  );
};
